module.exports = __webpack_public_path__ + "static/media/icon-folder.52a944b2.svg";